export enum CraftProcessState {
  DISABLED = 0, // 禁用
  ENABLED = 1, // 启用
}
